import axios from "axios";
import { PropallyLpV1ApiFactory } from "./generated/lp/api";

const axiosInstance = axios.create({ withCredentials: true });

// LP用API HTTPクライアント
export const PropallyLpApiFactory = () => {
  return PropallyLpV1ApiFactory(undefined, undefined, axiosInstance);
};
